import { withInstall } from '@tav-ui/utils/with-install'
import TableTags from './src/table-tags.vue'
const TaTableTags = withInstall(TableTags)
export { TaTableTags }
export default TaTableTags
export * from './src/types'
